module.exports = __webpack_public_path__ + "img/widderstein.15cc3b9a.jpg";